<template>
  <!-- Page Content -->
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header"><i class="fa fa-shield fa-fw"></i>Perfis</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <hr />
      <div class="row">
        <table class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Nome</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="profile in profiles"
              :key="profile.id"
              @mouseover="showByIndex = profile.id"
              @mouseout="showByIndex = null"
            >
              <td>{{ profile.id }}</td>
              <td>{{ lang.t(profile.name) }}</td>
              <td>
                <button
                  @click="exibirModal = 1; show = showByIndex"
                  type="button"
                  data-toggle="modal"
                  data-target="#showModal"
                  v-visible="showByIndex === profile.id"
                  class="btn btn-sm btn-primary"
                >
                  <i class="fa fa-eye fa-fw"></i>
                </button>
                <Modal v-if="exibirModal === 1 && show === profile.id">
                  <i slot="close" @click="exibirModal = false">&times;</i>
                  <h2 slot="header" class="modal-title" id="ModalLabel">
                    <i class="fa fa-users fa-fw"></i>
                    Usuários {{ lang.t(profile.name) }}
                  </h2>
                  <div slot="body">
                    <table
                      class="table table-bordered table-striped table-hover"
                    >
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="user in users"
                          :key="user.id"
                          v-show="user.profiles[0].id === profile.id"
                        >
                          <td>{{user.nome}}</td>
                          <td>{{user.email}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div slot="footer">
                    <button
                      class="btn btn-default"
                      @click="exibirModal = false"
                    >
                      fechar
                    </button>
                  </div>
                </Modal>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "../../components/ui-elements/Modal.vue";
import lang from "../../mixins/pt-br";

export default {
  name: "Profile",
  inject: ["loading"],
  components: { Modal },
  data() {
    return {
      lang,
      exibirModal: null,
      profiles: [],
      profile: { id: "", name: "" },
      users: [],
      user: { nome: "", email: ""},
      showByIndex: null,
      show: null,
    };
  },
  mounted() {
    this.loading.value = true;
    this.$http.get("profile").then((response) => {
      this.profiles = response.data.content;
      this.$http
          .get("/user")
          .then((response) => {
            this.users = response.data.content;
          })
          .catch((error) => console.log(error));
      setTimeout(() => (this.loading.value = false), 1000);
    });
  },
  methods: {
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Profile.vue